import { supabase } from '../lib/supabase';

export async function listProducts() {
  const { data, error } = await supabase
    .from('products')
    .select('*')
    .eq('is_active', true)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function createProduct(product) {
  const { data, error } = await supabase
    .from('products')
    .insert(product)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function updateProduct(id, updates) {
  const { data, error } = await supabase
    .from('products')
    .update(updates)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteProduct(id) {
  const { error } = await supabase
    .from('products')
    .delete()
    .eq('id', id);
  if (error) throw error;
}

export async function getProduct(id) {
  const { data, error } = await supabase
    .from('products')
    .select('*')
    .eq('id', id)
    .single();
  if (error) throw error;
  return data;
}

export async function uploadProductImage(file, fileName) {
  const path = `${Date.now()}-${fileName}`;
  const { data, error } = await supabase.storage
    .from('product-images')
    .upload(path, file, { upsert: false });
  if (error) throw error;
  const { data: urlData } = supabase.storage
    .from('product-images')
    .getPublicUrl(data.path);
  return urlData.publicUrl;
}


